module.exports = __webpack_public_path__ + "static/media/phone.9405f45c.png";